import React from "react";
import numeral from "numeral";

import "./styles.css";
import {
  RefiAnalysisType
} from "../../FilterSection/constants";

const Cell = ({ refiAnalysisType, loanTypeName, loanProceeds, cashout, ltvMax, debtYieldMin, dscrMin, spreadId, dealId }) => {
  const url = `/refiProceedsAnalysis/supervised/${dealId}/${spreadId}`;

  return (
    <div className="proceeds-card-container">
      <a href={url}>
        <div className="proceeds-card-cell-wrapper">
          <div className="proceeds-card-cell-lender-name">{loanTypeName}</div>
          <div className="proceeds-card-cell-proceeds-text">
            {refiAnalysisType === RefiAnalysisType.CASHOUT ?
              numeral(cashout).format("$0.00a") : numeral(loanProceeds).format("$0.00a")}
          </div>
          <div className="proceeds-card-cell-metrics-wrapper">
            <div>
              {numeral(ltvMax).format("0%")}
              {" "}
              LTV
            </div>
            <div>
              {numeral(debtYieldMin).format("0.00%")}
              {" "}
              DY
            </div>
            <div>
              {dscrMin}
              x DSCR
            </div>
          </div>
        </div>
      </a>
      <div className="proceeds-card-cell-separator" />
    </div>
  );
};

export default Cell;
